import {LoadingSpinner as PeacockLoadingSpinner} from '@pepsico-ds/ui'

/** @typedef {import('@pepsico-ds/ui').ILoadingSpinnerProps} LoadingSpinnerProps */

/** Wrapper around Peacock DS LoadingSpinner. @param {LoadingSpinnerProps} props */
export const LoadingSpinner = props => <PeacockLoadingSpinner {...props} />
